<template>
    <div>
        <b-button-group size="sm" class="w-100">
            <b-button
                variant="table"
                v-if="checkActionAllow('show')"
                @click="showItem(row)"
            >
                <i class="far fa-eye"></i>
            </b-button>
            <b-button
                variant="table"
                v-if="checkActionAllow('edit')"
                @click="editItem(row)"
            >
                <i class="fas fa-pencil-alt"></i>
            </b-button>
            <b-button
                variant="table"
                v-if="checkActionAllow('delete')"
                @click="deleteItem(row)"
            >
                <i class="fas fa-trash text-danger"></i>
            </b-button>
        </b-button-group>

        <div>
            <!-- v-if="checkActionAllow('approve') && row.item.selected_variant == 0" -->
            <span
                v-if="row.item.selected_variant == 0"
                class="table_actions_create_order"
                @click="approveOrderOutsourcing(row)"
            >
                Утвердить&nbsp;вариант
            </span>

            <!-- <span
                v-if="checkActionAllow('unApprove') && row.item.selected_variant == 0"
                class="table_actions_create_order disable pointer-event-none"
            >
                Утвердить&nbsp;вариант
            </span> -->

            <span
                v-if="row.item.selected_variant == 1"
                class="table_distribute-services"
                @click="approveOrderOutsourcing(row)"
            >
                Утверждён
            </span>
        </div>
    </div>
</template>
<script>
    import {
        checkActionAllow
    } from '@/mixins'

    export default {
        props: {
            row: {type: Object, required: true},                                                // Row of table
            actionAllows: {type: Array, required: false, default: function () { return [] }},   // Array of rules for action allows
        },
        mixins: [
            checkActionAllow
        ],
        data() {
            return {
            }
        },
        methods: {
            showItem(row) {
                this.$emit('showItem', row)
            },
            editItem(row) {
                this.$emit('editItem', row)
            },
            deleteItem(row) {
                this.$emit('deleteItem', row)
            },
            approveOrderOutsourcing(row) {
                this.$emit('approveOrderOutsourcing', row)
            }
        }
    }
</script>

